import { getField, updateField } from "vuex-map-fields";
import mutations from "./mutations"
import * as actions from "./actions"
export default {
    namespaced: true,
    state: {
        filter:{
            phone:null,
            agent_id:0,
            start_date:null,
            end_date:null,
        },
        isLoading: false,
        items: [],
        showMessage: false,
        message: "",
        isSuccess: false,
        currentItem: null,
        filterSearch:null,
        pagination:null

    },
    actions,
    getters: {
        getField,

    },
    mutations: {
        updateField,
        ...mutations,
    },
}


// {
//     field: 'actions', title: 'Actions', hide: false, cellRenderer: () => {
//         return ` `
//     }
// },